import React from "react"
import Nav from "./layout/nav"

import "../styles/main.scss"
import Ticker from "./layout/ticker"

class Layout extends React.Component {
  render() {
    const {
      location,
      title,
      description,
      projects,
      blogPosts,
      children,
      skills,
      position,
      phoneInt,
      phoneStr,
      email,
      logo,
      tickerItems
    } = this.props
    const rootPath = `${__PATH_PREFIX__}/`

    return (
      <div class="layout">
        <Nav
          title={title}
          projects={projects}
          description={description}
          skills={skills}
          position={position}
          phoneInt={phoneInt}
          phoneStr={phoneStr}
          email={email}
          location={location}
          logo={logo}
        />
        <main>{children}</main>
        <Ticker tickerItems={tickerItems}/>
      </div>
    )
  }
}

export default Layout
